<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form
      v-if="!isSuccess"
      id="login-form"
      class="login-form custom-form"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <ValidationProvider
        v-slot="{ errors }"
        mode="lazy"
        rules="required|email"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="email"
            ref="emailInput"
            v-model="email"
            type="email"
            autofocus
            name="email"
            :disabled="isPending"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: email.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_EMAIL'"
            for="email"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
          >
            <h4 
              v-t="'INPUT_EMAIL_ERROR'"
              class="menu-link text-uppercase error-tooltip__content"
            />
            <p 
              v-t="'INPUT_EMAIL_ERROR_DESCRIPTION'" 
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <fieldset class="login-form__field login-form__field--button">
        <div class="row">
          <div class="col-12">
            <SubmitButton
              :pending="isPending"
            >
              {{ $t('PASS_RECOVERY_BUTTON') }}
            </SubmitButton>
          </div>
          <div class="col-12">
            <a
              v-t="'BACK_LOGIN_LINK'"
              href="#"
              class="button button--transparent-grad pulse m-t-10"
              @click="goToLogin"
            />
          </div>
        </div>
      </fieldset>
    </form>
    <div
      v-if="isSuccess"
      class="success-message text-center"
    >
      <h1
        v-t="'PASS_RECOVERY_SUCCESS_TITLE'"
        class="title md-title"
      />
      <p
        v-t="'PASS_RECOVERY_SUCCESS_FIRST_LINE'"
        class="subtitle"
      />
      <p
        v-t="'PASS_RECOVERY_SUCCESS_SECOND_LINE'"
        class="subtitle"
      />
      <a
        v-t="'BACK_LOGIN_LINK'"
        href="#"
        class="button button--transparent-grad pulse m-t-40"
        @click="goToLogin"
      />
    </div>
  </ValidationObserver>
</template>

<script>
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import messages from '../locales';
import { STATUS_PENDING, STATUS_SUCCESS } from '@/store/helpers';

export default {
  components: {
    SubmitButton
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data: function () {
    return {
      email: '',
    };
  },
  computed: {
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    isSuccess() {
      return this.actionStatus.status === STATUS_SUCCESS;
    },
  },
  methods: {
    goToLogin() {
      $ngStateService.go('login');
    },
    onSubmit() {
      const { email } = this;
      this.$emit('forgot-password', { email });
    },
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>
</style>